/** 견적 폼 안내 문구용 숫자 포맷 (원화·할인율). */

const percentFormat = new Intl.NumberFormat('ko-KR', {
  style: 'percent',
  maximumFractionDigits: 20,
});

export const formatWon = (value: number) => value.toLocaleString('ko-KR');

/** 0.5 → "50%" (소수 할인율도 반올림하지 않는다) */
export const formatDiscountRate = (rate: number) => percentFormat.format(rate);

/** 330000 → "삼십삼만원". 견적서 문서와 CRM 접수 본문이 같은 표기를 쓴다. */
export function formatKoreanAmount(value: number): string {
  if (value === 0) return '영원';

  const digits = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
  const smallUnits = ['', '십', '백', '천'];
  const largeUnits = ['', '만', '억', '조'];
  const groups = Math.floor(value).toString().split('').reverse();
  const parts: string[] = [];

  for (let groupIndex = 0; groupIndex < groups.length; groupIndex += 4) {
    const groupDigits = groups.slice(groupIndex, groupIndex + 4);
    const groupText = groupDigits
      .map((digit, digitIndex) => {
        const number = Number(digit);
        if (number === 0 || Number.isNaN(number)) return '';
        if (number === 1 && digitIndex > 0) return smallUnits[digitIndex];
        return `${digits[number]}${smallUnits[digitIndex]}`;
      })
      .reverse()
      .join('');

    if (groupText) {
      parts.unshift(`${groupText}${largeUnits[groupIndex / 4]}`);
    }
  }

  return `${parts.join('')}원`;
}
